/* eslint-disable */
import format from 'date-fns/format';
import get from 'lodash/get';
import without from 'lodash/without';
import { REHYDRATE } from 'redux-persist';
import { ORDER_API_DATE_FORMAT, ORDER_PERSIST_KEY } from '../../../Constants/Order/Order.constants';
import { AUTH_STATE_CHANGED_NEXT } from '../Auth/Auth.types';
import {
  ORDERS_ALL,
  ORDERS_ALL_ADDRESSES,
  ORDERS_ALL_ADDRESSES_SUCCESS,
  ORDERS_ALL_ERROR,
  ORDERS_ALL_SUCCESS,
  ORDERS_CANCELLATION,
  ORDERS_CANCELLATION_COMPLETE,
  ORDERS_CANCELLATION_ERROR,
  ORDERS_CANCELLATION_SUCCESS,
  ORDERS_CONFIRMATION,
  ORDERS_CONFIRMATION_COMPLETE,
  ORDERS_CONFIRMATION_ERROR,
  ORDERS_CONFIRMATION_SUCCESS,
  ORDERS_FIND_BY_ID,
  ORDERS_FIND_BY_ID_COMPLETE,
  // this is commented out for now as there seem to be no reason to store errors in redux as AFAIK this is not use anywhere. It also causes issues when for whatever reason order has error and components try to display this order directly from redux
  // ORDERS_FIND_BY_ID_ERROR,
  ORDERS_FIND_BY_ID_SUCCESS,
  ORDERS_FIND_BY_STATUS,
  ORDERS_FIND_BY_STATUS_ERROR,
  ORDERS_FIND_BY_STATUS_SUCCESS,
  ORDERS_FIND_LINKED,
  ORDERS_FIND_LINKED_COMPLETE,
  ORDERS_FIND_LINKED_ERROR,
  ORDERS_FIND_LINKED_SUCCESS,
  ORDER_ID_UNSELECTED,
} from './Orders.types';

const ORDER_ENTITY_ID = `orderKey`;

/**
 * Create the state for the `ordersReducer` before `redux-persist` kicks in
 * @param {EntityService} entityService The `EntityService`
 * @returns {State} The initial state before `redux-persist` kicks in
 */
const createPrePersistOrdersState = (entityService) => entityService.create(ORDER_ENTITY_ID).get();

/**
 * Create the `ordersReducer`
 * @param {InjectablesForReducer} injectables The _injectable_'s required by this reducer
 * @returns {Reducer<State, OrdersActions>} The `ordersReducer`
 */
const ordersReducer = ({ entityService, orderService }) => (state = createPrePersistOrdersState(entityService), action) => {
  switch (action.type) {
    case REHYDRATE: {
      if (action.key !== ORDER_PERSIST_KEY || action.payload == null) {
        return state;
      }
      const { _persist, ...newState } = action.payload;
      return newState;
    }
    case AUTH_STATE_CHANGED_NEXT: {
      if (action.payload === null) {
        return {
          ...entityService
            .create(ORDER_ENTITY_ID)
            .loaded()
            .get(),
          addresses: {},
          error: null,
          selectedIdLoading: false,
        };
      }
      return state;
    }
    case ORDERS_ALL: {
      return {
        ...state,
        error: null,
        loading: true,
      };
    }
    case ORDERS_ALL_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case ORDERS_ALL_SUCCESS: {
      const [orderId] = state.selectedIds;
      const addresses = state.addresses || {};
      const { entities, ...otherEntityFields } = entityService
        .create(ORDER_ENTITY_ID)
        .loaded()
        .addAll(action.payload.orders)
        .get();
      const orderDetail = orderId && {
        [orderId]: {
          ...state.entities[orderId],
        },
      };
      return {
        ...state,
        ...otherEntityFields,
        addresses: {
          ...addresses,
        },
        entities: {
          ...entities,
          ...orderDetail,
        },
        selectedIds: state.selectedIds,
      };
    }
    case ORDERS_FIND_BY_ID: {
      const {
        params: { date, orderCode, orderLine },
      } = action.meta;
      const orderId = [format(date, ORDER_API_DATE_FORMAT).trim(), orderCode.trim(), orderLine.trim()].join(`-`);
      return {
        ...state,
        error: null,
        selectedIdLoading: true,
        selectedIds: [orderId],
      };
    }
    case ORDERS_FIND_BY_ID_SUCCESS: {
      const [orderId] = state.selectedIds;
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.payload.orderKey || orderId]: {
            ...action.payload,
            details: { ...action.payload.details, projectName: action.payload.details.projectName || `` },
          },
        },
      };
    }
    // case ORDERS_FIND_BY_ID_ERROR: {
    // const [orderId] = state.selectedIds;
    // return {
    //   ...state,
    //   entities: {
    //     ...state.entities,
    //     [orderId]: {
    //       ...state.entities[orderId],
    //       error: action.error,
    //     },
    //   },
    // };
    // }
    case ORDERS_FIND_BY_ID_COMPLETE: {
      return {
        ...state,
        orderConfirmationDone: null,
        orderConfirmationError: null,
        orderConfirmed: null,
        selectedIdLoading: false,
      };
    }
    case ORDER_ID_UNSELECTED: {
      const [orderId] = state.selectedIds;
      return {
        ...state,
        orderConfirmationDone: null,
        orderConfirmationError: null,
        orderConfirmed: null,
        selectedIdLoading: false,
        selectedIds: without(state.selectedIds, orderId),
      };
    }
    case ORDERS_ALL_ADDRESSES: {
      const addresses = state.addresses || {};
      return {
        ...state,
        addresses: {
          ...addresses,
          loading: true,
        },
      };
    }
    case ORDERS_ALL_ADDRESSES_SUCCESS: {
      return {
        ...state,
        addresses: {
          list: get(action, `payload.orders.addresses`, {}).map((address) => address.deliveryAddress),
          loading: false,
        },
      };
    }
    case ORDERS_FIND_BY_STATUS: {
      const {
        params: { orderCode, orderLine, status },
      } = action.meta;
      const orderStatusId = orderService.getStatusId({ orderCode, orderLine, status });
      return {
        ...state,
        [orderStatusId]: {
          ...state[orderStatusId],
          error: null,
          loading: true,
        },
      };
    }
    case ORDERS_FIND_BY_STATUS_SUCCESS: {
      const {
        params: { orderCode, orderLine, status },
      } = action.meta;
      const orderStatusId = orderService.getStatusId({ orderCode, orderLine, status });
      return {
        ...state,
        [orderStatusId]: {
          ...state[orderStatusId],
          data: action.payload,
          loading: false,
        },
      };
    }
    case ORDERS_FIND_BY_STATUS_ERROR: {
      const {
        params: { orderCode, orderLine, status },
      } = action.meta;
      const orderStatusId = orderService.getStatusId({ orderCode, orderLine, status });
      return {
        ...state,
        [orderStatusId]: {
          ...state[orderStatusId],
          error: action.error,
          loading: false,
        },
      };
    }
    // Separate the cancel reducer when needed
    case ORDERS_CANCELLATION:
    case ORDERS_CONFIRMATION: {
      return {
        ...state,
        orderConfirmationDone: false,
        orderConfirmationError: null,
        orderConfirmed: null,
      };
    }
    // Separate the cancel reducer when needed
    case ORDERS_CANCELLATION_SUCCESS:
    case ORDERS_CONFIRMATION_SUCCESS: {
      // Success response can also be an error.
      // Ideally, the error response should have the correct HTTP headers.
      // As discussed, it is currently a limitation due to an existing Angular
      // app depending on the body to check for errors.
      const isError = action.payload.status.toUpperCase() !== `SUCCESS`;
      return {
        ...state,
        orderConfirmed: !isError,
      };
    }
    // Separate the cancel reducer when needed
    case ORDERS_CANCELLATION_ERROR:
    case ORDERS_CONFIRMATION_ERROR: {
      return {
        ...state,
        orderConfirmationError: action.error,
        orderConfirmed: false,
      };
    }
    // Separate the cancel reducer when needed
    case ORDERS_CANCELLATION_COMPLETE:
    case ORDERS_CONFIRMATION_COMPLETE: {
      return {
        ...state,
        orderConfirmationDone: true,
      };
    }
    case ORDERS_FIND_LINKED: {
      return {
        ...state,
        linkedOrders: null,
        linkedOrdersLoading: true,
      };
    }
    case ORDERS_FIND_LINKED_SUCCESS: {
      return {
        ...state,
        linkedOrders: action.payload,
      };
    }
    case ORDERS_FIND_LINKED_ERROR: {
      return {
        ...state,
        linkedOrders: null,
      };
    }
    case ORDERS_FIND_LINKED_COMPLETE: {
      return {
        ...state,
        linkedOrdersLoading: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default ordersReducer;
